var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SCHOLARSHIP_AWARD_TYPES, } from '@backrs_ui/common-ui/src/models/scholarship';
var SHAPE_BANANA = 'M 5 58 C 15 8 85 8 95 58 C 72 32 28 32 5 58 Z';
var SHAPE_VERT_CRESCENT = 'M 42 5 C 92 15 92 85 42 95 C 68 72 68 28 42 5 Z';
var SHAPE_COMMA = 'M 68 10 C 92 20 95 52 80 60 C 92 76 72 92 55 82 C 52 94 38 90 40 78 C 25 82 12 65 28 58 C 15 48 22 30 38 35 C 50 10 58 6 68 10 Z';
var SHAPE_HOOK = 'M 78 12 C 95 35 88 70 68 70 C 72 85 52 90 45 78 C 30 88 15 72 25 60 C 40 55 58 62 62 52 C 65 42 55 38 45 45 C 38 48 32 45 32 38 C 30 25 48 18 60 25 C 68 15 75 10 78 12 Z';
var SHAPE_SPIRAL = 'M 18 22 C 40 8 62 18 60 35 C 58 48 38 45 35 58 C 32 72 55 72 60 58 C 78 58 88 75 78 88 C 62 95 40 92 30 80 C 15 82 8 62 22 55 C 10 48 8 32 18 22 Z';
var SHAPE_WISP = 'M 3 48 C 25 20 60 20 90 42 C 98 48 92 58 75 52 C 55 48 32 55 15 58 C 5 55 -2 52 3 48 Z';
var buildConfig = function (colors, blobs) { return ({
    baseColor: colors.base,
    blobs: blobs.map(function (b) { return ({
        top: b.t,
        left: b.l,
        right: b.rt,
        bottom: b.bt,
        width: b.w,
        height: b.h,
        shape: b.s,
        rotate: b.deg,
        color: colors[b.slot],
    }); }),
}); };
var BLUES_SOFT = {
    base: 'Beige/50',
    primary: 'Brand/200',
    secondary: 'Brand/100',
    accent: 'Brand/500',
};
var BLUES_DEEP = {
    base: 'Beige/50',
    primary: 'Brand/100',
    secondary: 'Brand/300',
    accent: 'Brand/700',
};
var BLUES_MID = {
    base: 'Beige/50',
    primary: 'Brand/200',
    secondary: 'Brand/300',
    accent: 'Brand/600',
};
var COOL_CRISP = {
    base: 'Brand/25',
    primary: 'Brand/200',
    secondary: 'Brand/100',
    accent: 'Brand/600',
};
var YELLOW_ACCENT = {
    base: 'Beige/50',
    primary: 'Brand/200',
    secondary: 'Brand/100',
    accent: 'Warning/400',
};
var YELLOW_LIGHT = {
    base: 'Beige/50',
    primary: 'Brand/100',
    secondary: 'Brand/200',
    accent: 'Warning/400',
};
var YELLOW_AIRY = {
    base: 'Beige/50',
    primary: 'Brand/100',
    secondary: 'Brand/50',
    accent: 'Warning/400',
};
var RED_ACCENT = {
    base: 'Beige/50',
    primary: 'Brand/100',
    secondary: 'Brand/200',
    accent: 'Error/400',
};
var RED_MID = {
    base: 'Beige/50',
    primary: 'Brand/200',
    secondary: 'Brand/300',
    accent: 'Error/400',
};
var RED_SOFT = {
    base: 'Beige/50',
    primary: 'Brand/100',
    secondary: 'Brand/50',
    accent: 'Error/400',
};
export var DEFAULT_CONFIG = buildConfig(BLUES_SOFT, [
    { slot: 'primary', t: '-20%', l: '-25%', w: '95%', h: '80%', s: SHAPE_BANANA, deg: -20 },
    { slot: 'secondary', t: '-10%', rt: '-20%', w: '70%', h: '65%', s: SHAPE_SPIRAL, deg: 35 },
    { slot: 'accent', bt: '-25%', rt: '-15%', w: '80%', h: '70%', s: SHAPE_HOOK, deg: 55 },
    { slot: 'base', t: '28%', l: '22%', w: '55%', h: '50%', s: SHAPE_VERT_CRESCENT, deg: 15 },
]);
export var PER_VARIANT = {
    scholarships: buildConfig(YELLOW_ACCENT, [
        { slot: 'primary', t: '-15%', rt: '-20%', w: '85%', h: '75%', s: SHAPE_COMMA, deg: 25 },
        { slot: 'secondary', bt: '-10%', l: '-15%', w: '75%', h: '65%', s: SHAPE_WISP, deg: -40 },
        { slot: 'accent', t: '30%', l: '10%', w: '55%', h: '50%', s: SHAPE_SPIRAL, deg: 15 },
        { slot: 'base', bt: '18%', rt: '10%', w: '45%', h: '45%', s: SHAPE_VERT_CRESCENT, deg: 60 },
    ]),
    article: buildConfig(BLUES_SOFT, [
        { slot: 'primary', t: '-18%', l: '-20%', w: '80%', h: '75%', s: SHAPE_VERT_CRESCENT, deg: 15 },
        { slot: 'secondary', bt: '-15%', rt: '-10%', w: '70%', h: '65%', s: SHAPE_HOOK, deg: -30 },
        { slot: 'accent', t: '20%', rt: '5%', w: '50%', h: '45%', s: SHAPE_COMMA, deg: 40 },
        { slot: 'base', bt: '20%', l: '15%', w: '45%', h: '45%', s: SHAPE_WISP, deg: 10 },
    ]),
    'video-external': buildConfig(BLUES_MID, [
        { slot: 'primary', t: '-15%', l: '15%', w: '80%', h: '70%', s: SHAPE_BANANA, deg: 35 },
        { slot: 'secondary', bt: '-20%', l: '-20%', w: '70%', h: '65%', s: SHAPE_SPIRAL, deg: -25 },
        { slot: 'accent', t: '25%', rt: '-15%', w: '55%', h: '50%', s: SHAPE_HOOK, deg: 20 },
        { slot: 'base', bt: '10%', rt: '15%', w: '40%', h: '40%', s: SHAPE_VERT_CRESCENT, deg: -40 },
    ]),
    'video-internal': buildConfig(COOL_CRISP, [
        { slot: 'primary', bt: '-20%', rt: '-10%', w: '80%', h: '70%', s: SHAPE_WISP, deg: 30 },
        { slot: 'secondary', t: '-15%', l: '10%', w: '65%', h: '60%', s: SHAPE_COMMA, deg: -20 },
        { slot: 'accent', t: '15%', rt: '-15%', w: '50%', h: '50%', s: SHAPE_SPIRAL, deg: 40 },
        { slot: 'base', bt: '25%', l: '-10%', w: '45%', h: '45%', s: SHAPE_BANANA, deg: -15 },
    ]),
    'text-response': buildConfig(YELLOW_LIGHT, [
        { slot: 'primary', t: '-20%', l: '-10%', w: '75%', h: '70%', s: SHAPE_SPIRAL, deg: -25 },
        {
            slot: 'secondary',
            bt: '-15%',
            rt: '5%',
            w: '70%',
            h: '60%',
            s: SHAPE_VERT_CRESCENT,
            deg: 45,
        },
        { slot: 'accent', t: '30%', rt: '15%', w: '50%', h: '45%', s: SHAPE_WISP, deg: -10 },
        { slot: 'base', bt: '25%', l: '20%', w: '40%', h: '40%', s: SHAPE_HOOK, deg: 30 },
    ]),
    post: buildConfig(BLUES_SOFT, [
        { slot: 'primary', t: '-10%', rt: '-20%', w: '75%', h: '70%', s: SHAPE_HOOK, deg: 25 },
        { slot: 'secondary', bt: '-15%', l: '5%', w: '75%', h: '65%', s: SHAPE_COMMA, deg: -30 },
        { slot: 'accent', t: '20%', l: '-10%', w: '55%', h: '50%', s: SHAPE_WISP, deg: 10 },
        { slot: 'base', bt: '20%', rt: '15%', w: '40%', h: '45%', s: SHAPE_BANANA, deg: -40 },
    ]),
    audio: buildConfig(BLUES_DEEP, [
        { slot: 'primary', t: '-25%', l: '-20%', w: '90%', h: '75%', s: SHAPE_COMMA, deg: -15 },
        {
            slot: 'secondary',
            bt: '-20%',
            rt: '-15%',
            w: '75%',
            h: '65%',
            s: SHAPE_VERT_CRESCENT,
            deg: 40,
        },
        { slot: 'accent', t: '30%', rt: '20%', w: '45%', h: '45%', s: SHAPE_BANANA, deg: 20 },
        { slot: 'base', bt: '15%', l: '15%', w: '45%', h: '45%', s: SHAPE_HOOK, deg: -25 },
    ]),
    document: buildConfig(BLUES_MID, [
        { slot: 'primary', t: '-15%', l: '-15%', w: '75%', h: '70%', s: SHAPE_WISP, deg: -20 },
        { slot: 'accent', t: '10%', rt: '-10%', w: '55%', h: '55%', s: SHAPE_HOOK, deg: 45 },
        { slot: 'secondary', bt: '-20%', l: '15%', w: '75%', h: '60%', s: SHAPE_SPIRAL, deg: 25 },
        { slot: 'base', t: '35%', l: '25%', w: '40%', h: '40%', s: SHAPE_COMMA, deg: -35 },
    ]),
    'profile-external': buildConfig(YELLOW_AIRY, [
        { slot: 'primary', t: '-20%', rt: '-15%', w: '80%', h: '75%', s: SHAPE_HOOK, deg: 30 },
        { slot: 'secondary', bt: '-15%', l: '-20%', w: '75%', h: '65%', s: SHAPE_BANANA, deg: -25 },
        { slot: 'accent', t: '30%', l: '20%', w: '45%', h: '45%', s: SHAPE_VERT_CRESCENT, deg: 15 },
        { slot: 'base', bt: '20%', rt: '10%', w: '40%', h: '45%', s: SHAPE_WISP, deg: -40 },
    ]),
    'profile-internal': buildConfig(BLUES_SOFT, [
        { slot: 'primary', bt: '-15%', l: '-15%', w: '80%', h: '70%', s: SHAPE_BANANA, deg: 40 },
        { slot: 'secondary', t: '-20%', rt: '-10%', w: '70%', h: '65%', s: SHAPE_WISP, deg: -30 },
        { slot: 'accent', t: '25%', l: '15%', w: '50%', h: '50%', s: SHAPE_HOOK, deg: 20 },
        { slot: 'base', bt: '25%', rt: '20%', w: '40%', h: '40%', s: SHAPE_SPIRAL, deg: -15 },
    ]),
    institution: buildConfig(BLUES_DEEP, [
        { slot: 'primary', t: '-15%', l: '-20%', w: '85%', h: '75%', s: SHAPE_HOOK, deg: -15 },
        { slot: 'secondary', bt: '-20%', rt: '-10%', w: '75%', h: '65%', s: SHAPE_WISP, deg: 30 },
        { slot: 'accent', t: '25%', rt: '20%', w: '50%', h: '45%', s: SHAPE_COMMA, deg: 50 },
        { slot: 'base', bt: '15%', l: '20%', w: '40%', h: '40%', s: SHAPE_VERT_CRESCENT, deg: -25 },
    ]),
    opportunity: buildConfig(YELLOW_ACCENT, [
        { slot: 'primary', t: '-10%', l: '-15%', w: '75%', h: '70%', s: SHAPE_COMMA, deg: 20 },
        { slot: 'secondary', bt: '-15%', rt: '-15%', w: '75%', h: '65%', s: SHAPE_HOOK, deg: -35 },
        { slot: 'accent', t: '30%', rt: '10%', w: '55%', h: '45%', s: SHAPE_BANANA, deg: 15 },
        { slot: 'base', bt: '25%', l: '15%', w: '40%', h: '40%', s: SHAPE_WISP, deg: 40 },
    ]),
    event: buildConfig(YELLOW_LIGHT, [
        { slot: 'primary', t: '-20%', rt: '-15%', w: '85%', h: '75%', s: SHAPE_SPIRAL, deg: 30 },
        { slot: 'secondary', bt: '-15%', l: '-20%', w: '75%', h: '65%', s: SHAPE_HOOK, deg: -30 },
        { slot: 'accent', t: '20%', l: '20%', w: '55%', h: '45%', s: SHAPE_WISP, deg: 20 },
        { slot: 'base', bt: '20%', rt: '15%', w: '40%', h: '40%', s: SHAPE_COMMA, deg: -40 },
    ]),
    book: buildConfig(BLUES_MID, [
        { slot: 'primary', t: '-18%', l: '-10%', w: '80%', h: '75%', s: SHAPE_VERT_CRESCENT, deg: -25 },
        { slot: 'accent', t: '15%', rt: '-15%', w: '55%', h: '55%', s: SHAPE_SPIRAL, deg: 35 },
        { slot: 'secondary', bt: '-20%', l: '15%', w: '70%', h: '60%', s: SHAPE_BANANA, deg: 45 },
        { slot: 'base', bt: '30%', rt: '25%', w: '35%', h: '35%', s: SHAPE_WISP, deg: -20 },
    ]),
    competency: buildConfig(BLUES_SOFT, [
        { slot: 'primary', t: '-25%', l: '-20%', w: '90%', h: '80%', s: SHAPE_WISP, deg: -20 },
        {
            slot: 'secondary',
            bt: '-15%',
            rt: '-15%',
            w: '70%',
            h: '60%',
            s: SHAPE_VERT_CRESCENT,
            deg: 35,
        },
        { slot: 'accent', t: '25%', rt: '15%', w: '50%', h: '45%', s: SHAPE_COMMA, deg: 15 },
        { slot: 'base', bt: '20%', l: '10%', w: '40%', h: '40%', s: SHAPE_HOOK, deg: -35 },
    ]),
    'career-path': buildConfig(YELLOW_ACCENT, [
        { slot: 'primary', t: '-15%', l: '-25%', w: '90%', h: '75%', s: SHAPE_BANANA, deg: -30 },
        { slot: 'secondary', bt: '-10%', rt: '-10%', w: '70%', h: '60%', s: SHAPE_COMMA, deg: 45 },
        { slot: 'accent', t: '10%', rt: '10%', w: '55%', h: '50%', s: SHAPE_WISP, deg: 20 },
        { slot: 'base', bt: '25%', l: '15%', w: '40%', h: '40%', s: SHAPE_HOOK, deg: -20 },
    ]),
    'career-track': buildConfig(BLUES_DEEP, [
        { slot: 'primary', t: '-20%', rt: '-10%', w: '80%', h: '70%', s: SHAPE_COMMA, deg: 40 },
        { slot: 'secondary', bt: '-15%', l: '-15%', w: '80%', h: '65%', s: SHAPE_SPIRAL, deg: -25 },
        { slot: 'accent', t: '25%', l: '25%', w: '50%', h: '45%', s: SHAPE_VERT_CRESCENT, deg: 10 },
        { slot: 'base', bt: '20%', rt: '10%', w: '40%', h: '40%', s: SHAPE_BANANA, deg: -40 },
    ]),
    resource: buildConfig(RED_ACCENT, [
        { slot: 'primary', t: '-18%', l: '-15%', w: '80%', h: '70%', s: SHAPE_SPIRAL, deg: 20 },
        { slot: 'secondary', bt: '-20%', rt: '-10%', w: '70%', h: '60%', s: SHAPE_BANANA, deg: -35 },
        { slot: 'accent', t: '25%', rt: '20%', w: '50%', h: '45%', s: SHAPE_WISP, deg: 15 },
        { slot: 'base', bt: '20%', l: '10%', w: '40%', h: '40%', s: SHAPE_HOOK, deg: 40 },
    ]),
    'track-assessment-result': buildConfig(YELLOW_AIRY, [
        { slot: 'primary', t: '-20%', l: '-20%', w: '85%', h: '75%', s: SHAPE_HOOK, deg: -25 },
        { slot: 'secondary', bt: '-15%', rt: '-15%', w: '75%', h: '65%', s: SHAPE_COMMA, deg: 35 },
        { slot: 'accent', t: '30%', rt: '15%', w: '45%', h: '45%', s: SHAPE_BANANA, deg: 20 },
        { slot: 'base', bt: '25%', l: '15%', w: '40%', h: '40%', s: SHAPE_VERT_CRESCENT, deg: -40 },
    ]),
    'track-assessment-unlock': buildConfig(COOL_CRISP, [
        { slot: 'primary', t: '-15%', rt: '-20%', w: '80%', h: '70%', s: SHAPE_BANANA, deg: 30 },
        { slot: 'secondary', bt: '-15%', l: '-10%', w: '75%', h: '65%', s: SHAPE_WISP, deg: -25 },
        { slot: 'accent', t: '25%', l: '20%', w: '55%', h: '50%', s: SHAPE_SPIRAL, deg: 15 },
        { slot: 'base', bt: '20%', rt: '20%', w: '40%', h: '40%', s: SHAPE_HOOK, deg: -35 },
    ]),
    employer: buildConfig(BLUES_DEEP, [
        { slot: 'primary', t: '-10%', l: '-20%', w: '80%', h: '70%', s: SHAPE_VERT_CRESCENT, deg: -20 },
        { slot: 'secondary', t: '-20%', rt: '-20%', w: '70%', h: '65%', s: SHAPE_HOOK, deg: 35 },
        { slot: 'accent', bt: '-15%', l: '20%', w: '55%', h: '50%', s: SHAPE_COMMA, deg: 45 },
        { slot: 'base', bt: '25%', rt: '15%', w: '40%', h: '40%', s: SHAPE_BANANA, deg: 10 },
    ]),
    'educational-investment': buildConfig(YELLOW_ACCENT, [
        { slot: 'primary', bt: '-15%', l: '-15%', w: '80%', h: '70%', s: SHAPE_WISP, deg: -30 },
        { slot: 'secondary', t: '-20%', rt: '-15%', w: '70%', h: '65%', s: SHAPE_SPIRAL, deg: 40 },
        { slot: 'accent', t: '25%', l: '15%', w: '50%', h: '50%', s: SHAPE_HOOK, deg: -15 },
        { slot: 'base', bt: '20%', rt: '20%', w: '40%', h: '40%', s: SHAPE_COMMA, deg: 25 },
    ]),
    tool: buildConfig(BLUES_SOFT, [
        { slot: 'primary', t: '-25%', rt: '-15%', w: '85%', h: '75%', s: SHAPE_COMMA, deg: 25 },
        { slot: 'secondary', bt: '-20%', l: '-10%', w: '75%', h: '65%', s: SHAPE_BANANA, deg: -35 },
        { slot: 'accent', t: '20%', l: '25%', w: '50%', h: '45%', s: SHAPE_VERT_CRESCENT, deg: 40 },
        { slot: 'base', bt: '25%', rt: '15%', w: '40%', h: '40%', s: SHAPE_SPIRAL, deg: -20 },
    ]),
    major: buildConfig(BLUES_MID, [
        { slot: 'primary', t: '-15%', l: '-20%', w: '80%', h: '70%', s: SHAPE_HOOK, deg: -25 },
        {
            slot: 'secondary',
            bt: '-15%',
            rt: '-15%',
            w: '75%',
            h: '65%',
            s: SHAPE_VERT_CRESCENT,
            deg: 40,
        },
        { slot: 'accent', t: '25%', rt: '20%', w: '50%', h: '45%', s: SHAPE_BANANA, deg: 15 },
        { slot: 'base', bt: '20%', l: '15%', w: '40%', h: '40%', s: SHAPE_COMMA, deg: -35 },
    ]),
    industry: buildConfig(BLUES_DEEP, [
        { slot: 'primary', t: '-10%', rt: '-15%', w: '80%', h: '70%', s: SHAPE_WISP, deg: 30 },
        { slot: 'secondary', bt: '-20%', l: '-10%', w: '75%', h: '65%', s: SHAPE_COMMA, deg: -25 },
        { slot: 'accent', t: '20%', l: '20%', w: '55%', h: '45%', s: SHAPE_HOOK, deg: 50 },
        { slot: 'base', bt: '25%', rt: '20%', w: '40%', h: '40%', s: SHAPE_SPIRAL, deg: -10 },
    ]),
    coach: buildConfig(RED_SOFT, [
        { slot: 'primary', t: '-20%', l: '-15%', w: '85%', h: '75%', s: SHAPE_HOOK, deg: -20 },
        { slot: 'secondary', bt: '-15%', rt: '-15%', w: '75%', h: '65%', s: SHAPE_BANANA, deg: 35 },
        { slot: 'accent', t: '25%', rt: '-5%', w: '60%', h: '35%', s: SHAPE_COMMA, deg: -30 },
        { slot: 'base', bt: '20%', l: '15%', w: '40%', h: '40%', s: SHAPE_WISP, deg: 20 },
    ]),
    'deep-dive': buildConfig(RED_MID, [
        { slot: 'primary', t: '-15%', rt: '-20%', w: '80%', h: '70%', s: SHAPE_SPIRAL, deg: 25 },
        { slot: 'secondary', bt: '-15%', l: '-15%', w: '75%', h: '65%', s: SHAPE_WISP, deg: -35 },
        { slot: 'accent', t: '20%', l: '15%', w: '55%', h: '50%', s: SHAPE_VERT_CRESCENT, deg: 15 },
        { slot: 'base', bt: '25%', rt: '20%', w: '40%', h: '40%', s: SHAPE_COMMA, deg: 45 },
    ]),
    playlist: buildConfig(BLUES_SOFT, [
        { slot: 'primary', bt: '-20%', l: '-20%', w: '85%', h: '75%', s: SHAPE_COMMA, deg: -30 },
        { slot: 'secondary', t: '-15%', rt: '-10%', w: '70%', h: '65%', s: SHAPE_HOOK, deg: 35 },
        { slot: 'accent', t: '20%', l: '15%', w: '55%', h: '45%', s: SHAPE_BANANA, deg: 25 },
        { slot: 'base', bt: '25%', rt: '15%', w: '40%', h: '40%', s: SHAPE_VERT_CRESCENT, deg: -15 },
    ]),
    'solution-session': buildConfig(COOL_CRISP, [
        { slot: 'primary', t: '-15%', l: '-15%', w: '80%', h: '70%', s: SHAPE_BANANA, deg: 20 },
        { slot: 'secondary', bt: '-15%', rt: '-20%', w: '75%', h: '65%', s: SHAPE_SPIRAL, deg: -30 },
        { slot: 'accent', t: '15%', rt: '15%', w: '55%', h: '50%', s: SHAPE_WISP, deg: 45 },
        { slot: 'base', bt: '25%', l: '15%', w: '40%', h: '40%', s: SHAPE_VERT_CRESCENT, deg: -40 },
    ]),
};
var FIELD_PALETTES = {
    agriculture: { base: 'Beige/50', primary: 'Brand/50', secondary: 'Brand/200' },
    arts: { base: 'Beige/50', primary: 'Brand/200', secondary: 'Brand/100' },
    business: { base: 'Beige/50', primary: 'Brand/100', secondary: 'Brand/300' },
    education: { base: 'Brand/25', primary: 'Brand/100', secondary: 'Brand/200' },
    law: { base: 'Beige/50', primary: 'Brand/200', secondary: 'Brand/300' },
    'patient-care': { base: 'Beige/50', primary: 'Brand/100', secondary: 'Brand/50' },
    'social-sector': { base: 'Beige/100', primary: 'Brand/100', secondary: 'Brand/200' },
    stem: { base: 'Brand/25', primary: 'Brand/200', secondary: 'Brand/300' },
    trades: { base: 'Beige/50', primary: 'Brand/300', secondary: 'Brand/200' },
};
var PATH_COMPOSITIONS = {
    animal_health: [
        { slot: 'primary', l: '-19%', bt: '-12%', w: '85%', h: '66%', s: SHAPE_COMMA, deg: -36 },
        { slot: 'secondary', t: '-20%', rt: '-24%', w: '64%', h: '67%', s: SHAPE_BANANA, deg: -11 },
        { slot: 'accent', l: '22%', bt: '34%', w: '65%', h: '56%', s: SHAPE_COMMA, deg: 9 },
        { slot: 'base', rt: '22%', bt: '35%', w: '65%', h: '71%', s: SHAPE_HOOK, deg: 26 },
    ],
    farming: [
        { slot: 'primary', t: '24%', l: '35%', w: '63%', h: '75%', s: SHAPE_VERT_CRESCENT, deg: -8 },
        { slot: 'secondary', t: '-9%', l: '-15%', w: '64%', h: '72%', s: SHAPE_COMMA, deg: 47 },
        { slot: 'accent', rt: '38%', bt: '16%', w: '62%', h: '58%', s: SHAPE_VERT_CRESCENT, deg: -49 },
        { slot: 'base', rt: '-19%', bt: '-6%', w: '76%', h: '80%', s: SHAPE_VERT_CRESCENT, deg: -3 },
    ],
    food_systems: [
        { slot: 'primary', rt: '22%', bt: '19%', w: '74%', h: '60%', s: SHAPE_BANANA, deg: 21 },
        { slot: 'secondary', t: '27%', l: '35%', w: '82%', h: '63%', s: SHAPE_SPIRAL, deg: -21 },
        { slot: 'accent', t: '-13%', rt: '-17%', w: '81%', h: '68%', s: SHAPE_BANANA, deg: 38 },
        { slot: 'base', rt: '-7%', bt: '-22%', w: '79%', h: '66%', s: SHAPE_SPIRAL, deg: -35 },
    ],
    architecture: [
        { slot: 'primary', l: '31%', bt: '39%', w: '77%', h: '74%', s: SHAPE_COMMA, deg: 23 },
        { slot: 'secondary', rt: '-17%', bt: '-8%', w: '79%', h: '66%', s: SHAPE_COMMA, deg: 24 },
        { slot: 'accent', t: '38%', rt: '39%', w: '72%', h: '64%', s: SHAPE_SPIRAL, deg: -23 },
        { slot: 'base', t: '34%', l: '28%', w: '69%', h: '66%', s: SHAPE_BANANA, deg: -1 },
    ],
    creator_artist: [
        { slot: 'primary', t: '26%', l: '38%', w: '66%', h: '74%', s: SHAPE_SPIRAL, deg: 16 },
        {
            slot: 'secondary',
            l: '-18%',
            bt: '-30%',
            w: '68%',
            h: '77%',
            s: SHAPE_VERT_CRESCENT,
            deg: 26,
        },
        { slot: 'accent', l: '21%', bt: '33%', w: '60%', h: '75%', s: SHAPE_VERT_CRESCENT, deg: -23 },
        { slot: 'base', t: '-27%', l: '-18%', w: '85%', h: '61%', s: SHAPE_BANANA, deg: 35 },
    ],
    design: [
        { slot: 'primary', rt: '39%', bt: '38%', w: '65%', h: '78%', s: SHAPE_COMMA, deg: -48 },
        { slot: 'secondary', t: '16%', rt: '26%', w: '80%', h: '71%', s: SHAPE_COMMA, deg: -9 },
        { slot: 'accent', l: '40%', bt: '20%', w: '84%', h: '62%', s: SHAPE_WISP, deg: 35 },
        { slot: 'base', l: '-13%', bt: '-5%', w: '84%', h: '79%', s: SHAPE_WISP, deg: -28 },
    ],
    entertainment_sports: [
        { slot: 'primary', t: '21%', l: '29%', w: '78%', h: '61%', s: SHAPE_BANANA, deg: 26 },
        { slot: 'secondary', l: '20%', bt: '28%', w: '69%', h: '62%', s: SHAPE_HOOK, deg: -20 },
        { slot: 'accent', t: '-6%', rt: '-24%', w: '82%', h: '60%', s: SHAPE_BANANA, deg: -35 },
        { slot: 'base', l: '-16%', bt: '-23%', w: '79%', h: '57%', s: SHAPE_WISP, deg: 5 },
    ],
    fashion_textiles: [
        { slot: 'primary', t: '-24%', l: '-17%', w: '62%', h: '68%', s: SHAPE_BANANA, deg: 7 },
        { slot: 'secondary', l: '19%', bt: '21%', w: '84%', h: '72%', s: SHAPE_BANANA, deg: -37 },
        { slot: 'accent', t: '16%', rt: '29%', w: '71%', h: '74%', s: SHAPE_SPIRAL, deg: -46 },
        { slot: 'base', l: '-21%', bt: '-19%', w: '73%', h: '63%', s: SHAPE_HOOK, deg: -38 },
    ],
    film_music_photography: [
        { slot: 'primary', rt: '18%', bt: '38%', w: '76%', h: '72%', s: SHAPE_HOOK, deg: -22 },
        { slot: 'secondary', l: '22%', bt: '38%', w: '78%', h: '71%', s: SHAPE_COMMA, deg: 4 },
        { slot: 'accent', rt: '-8%', bt: '-8%', w: '71%', h: '77%', s: SHAPE_VERT_CRESCENT, deg: 18 },
        { slot: 'base', l: '-29%', bt: '-22%', w: '82%', h: '60%', s: SHAPE_HOOK, deg: -1 },
    ],
    media_journalism: [
        { slot: 'primary', l: '-29%', bt: '-28%', w: '85%', h: '78%', s: SHAPE_BANANA, deg: -11 },
        { slot: 'secondary', t: '-20%', l: '-19%', w: '83%', h: '62%', s: SHAPE_SPIRAL, deg: 44 },
        { slot: 'accent', rt: '-20%', bt: '-26%', w: '77%', h: '68%', s: SHAPE_COMMA, deg: -21 },
        { slot: 'base', t: '-21%', rt: '-20%', w: '73%', h: '56%', s: SHAPE_HOOK, deg: -46 },
    ],
    performing_arts: [
        { slot: 'primary', rt: '30%', bt: '28%', w: '71%', h: '67%', s: SHAPE_WISP, deg: -8 },
        {
            slot: 'secondary',
            t: '-13%',
            l: '-13%',
            w: '64%',
            h: '59%',
            s: SHAPE_VERT_CRESCENT,
            deg: -10,
        },
        { slot: 'accent', t: '-21%', rt: '-15%', w: '63%', h: '70%', s: SHAPE_HOOK, deg: -8 },
        { slot: 'base', t: '36%', rt: '35%', w: '79%', h: '63%', s: SHAPE_HOOK, deg: -25 },
    ],
    writing_copywriting: [
        { slot: 'primary', rt: '29%', bt: '31%', w: '78%', h: '56%', s: SHAPE_WISP, deg: -17 },
        { slot: 'secondary', t: '-17%', rt: '-11%', w: '76%', h: '68%', s: SHAPE_SPIRAL, deg: 50 },
        { slot: 'accent', t: '21%', rt: '23%', w: '82%', h: '65%', s: SHAPE_COMMA, deg: -26 },
        { slot: 'base', l: '25%', bt: '18%', w: '61%', h: '62%', s: SHAPE_VERT_CRESCENT, deg: -18 },
    ],
    accounting: [
        { slot: 'primary', t: '-21%', rt: '-16%', w: '82%', h: '71%', s: SHAPE_SPIRAL, deg: -21 },
        { slot: 'secondary', l: '29%', bt: '19%', w: '69%', h: '69%', s: SHAPE_HOOK, deg: -38 },
        { slot: 'accent', rt: '-19%', bt: '-14%', w: '76%', h: '63%', s: SHAPE_BANANA, deg: 25 },
        { slot: 'base', rt: '17%', bt: '25%', w: '68%', h: '56%', s: SHAPE_BANANA, deg: -21 },
    ],
    administrative_support: [
        { slot: 'primary', t: '15%', rt: '38%', w: '82%', h: '64%', s: SHAPE_BANANA, deg: 26 },
        { slot: 'secondary', l: '19%', bt: '15%', w: '68%', h: '66%', s: SHAPE_WISP, deg: -43 },
        { slot: 'accent', t: '31%', l: '21%', w: '79%', h: '65%', s: SHAPE_WISP, deg: 15 },
        { slot: 'base', t: '-7%', l: '-24%', w: '66%', h: '56%', s: SHAPE_HOOK, deg: -27 },
    ],
    entrepreneurship: [
        {
            slot: 'primary',
            rt: '-28%',
            bt: '-22%',
            w: '69%',
            h: '64%',
            s: SHAPE_VERT_CRESCENT,
            deg: -48,
        },
        { slot: 'secondary', t: '33%', l: '21%', w: '67%', h: '57%', s: SHAPE_WISP, deg: 46 },
        { slot: 'accent', rt: '24%', bt: '36%', w: '61%', h: '67%', s: SHAPE_BANANA, deg: -10 },
        { slot: 'base', t: '-26%', l: '-11%', w: '63%', h: '70%', s: SHAPE_COMMA, deg: 13 },
    ],
    finance: [
        { slot: 'primary', l: '-25%', bt: '-17%', w: '83%', h: '66%', s: SHAPE_BANANA, deg: -23 },
        { slot: 'secondary', rt: '-16%', bt: '-20%', w: '81%', h: '64%', s: SHAPE_COMMA, deg: 35 },
        { slot: 'accent', t: '-26%', l: '-12%', w: '68%', h: '71%', s: SHAPE_SPIRAL, deg: -2 },
        { slot: 'base', rt: '35%', bt: '28%', w: '80%', h: '59%', s: SHAPE_BANANA, deg: 37 },
    ],
    human_capital: [
        { slot: 'primary', l: '21%', bt: '29%', w: '77%', h: '75%', s: SHAPE_VERT_CRESCENT, deg: -26 },
        { slot: 'secondary', rt: '31%', bt: '20%', w: '78%', h: '62%', s: SHAPE_COMMA, deg: 19 },
        { slot: 'accent', l: '-16%', bt: '-13%', w: '75%', h: '69%', s: SHAPE_COMMA, deg: -44 },
        { slot: 'base', t: '17%', l: '37%', w: '68%', h: '66%', s: SHAPE_HOOK, deg: 11 },
    ],
    investment_banking: [
        { slot: 'primary', l: '19%', bt: '20%', w: '74%', h: '65%', s: SHAPE_HOOK, deg: -30 },
        { slot: 'secondary', l: '-14%', bt: '-18%', w: '62%', h: '79%', s: SHAPE_SPIRAL, deg: 38 },
        { slot: 'accent', t: '-18%', rt: '-27%', w: '79%', h: '61%', s: SHAPE_WISP, deg: -30 },
        { slot: 'base', t: '30%', rt: '20%', w: '65%', h: '75%', s: SHAPE_VERT_CRESCENT, deg: -19 },
    ],
    general_management: [
        { slot: 'primary', t: '28%', rt: '28%', w: '81%', h: '58%', s: SHAPE_COMMA, deg: 8 },
        { slot: 'secondary', t: '-20%', rt: '-16%', w: '62%', h: '57%', s: SHAPE_HOOK, deg: 21 },
        { slot: 'accent', rt: '27%', bt: '36%', w: '65%', h: '57%', s: SHAPE_BANANA, deg: 11 },
        { slot: 'base', t: '22%', l: '19%', w: '82%', h: '62%', s: SHAPE_WISP, deg: 44 },
    ],
    management_consulting: [
        { slot: 'primary', rt: '25%', bt: '36%', w: '84%', h: '61%', s: SHAPE_BANANA, deg: -22 },
        {
            slot: 'secondary',
            t: '29%',
            rt: '20%',
            w: '65%',
            h: '79%',
            s: SHAPE_VERT_CRESCENT,
            deg: -35,
        },
        { slot: 'accent', t: '-22%', l: '-27%', w: '68%', h: '64%', s: SHAPE_WISP, deg: 43 },
        { slot: 'base', t: '37%', l: '39%', w: '68%', h: '60%', s: SHAPE_COMMA, deg: -26 },
    ],
    marketing_public_relations: [
        { slot: 'primary', t: '-21%', l: '-19%', w: '79%', h: '60%', s: SHAPE_COMMA, deg: 11 },
        { slot: 'secondary', l: '17%', bt: '24%', w: '83%', h: '60%', s: SHAPE_HOOK, deg: 32 },
        { slot: 'accent', l: '-18%', bt: '-29%', w: '66%', h: '69%', s: SHAPE_COMMA, deg: -40 },
        { slot: 'base', t: '32%', l: '35%', w: '82%', h: '71%', s: SHAPE_HOOK, deg: -32 },
    ],
    operations: [
        { slot: 'primary', rt: '-11%', bt: '-13%', w: '60%', h: '58%', s: SHAPE_BANANA, deg: -32 },
        { slot: 'secondary', t: '-18%', l: '-26%', w: '74%', h: '61%', s: SHAPE_HOOK, deg: 28 },
        { slot: 'accent', l: '-11%', bt: '-13%', w: '63%', h: '72%', s: SHAPE_COMMA, deg: -50 },
        { slot: 'base', rt: '31%', bt: '16%', w: '72%', h: '59%', s: SHAPE_VERT_CRESCENT, deg: 32 },
    ],
    product_management: [
        { slot: 'primary', l: '-9%', bt: '-6%', w: '60%', h: '73%', s: SHAPE_VERT_CRESCENT, deg: -41 },
        { slot: 'secondary', t: '40%', rt: '36%', w: '72%', h: '74%', s: SHAPE_BANANA, deg: -5 },
        { slot: 'accent', l: '40%', bt: '31%', w: '65%', h: '76%', s: SHAPE_VERT_CRESCENT, deg: -31 },
        { slot: 'base', t: '35%', l: '19%', w: '78%', h: '64%', s: SHAPE_HOOK, deg: 45 },
    ],
    real_estate: [
        { slot: 'primary', t: '26%', rt: '37%', w: '80%', h: '71%', s: SHAPE_VERT_CRESCENT, deg: -41 },
        { slot: 'secondary', rt: '-13%', bt: '-19%', w: '69%', h: '78%', s: SHAPE_WISP, deg: 1 },
        { slot: 'accent', t: '23%', l: '35%', w: '70%', h: '79%', s: SHAPE_HOOK, deg: 16 },
        { slot: 'base', rt: '20%', bt: '18%', w: '80%', h: '78%', s: SHAPE_SPIRAL, deg: -31 },
    ],
    sales: [
        { slot: 'primary', rt: '23%', bt: '26%', w: '66%', h: '61%', s: SHAPE_BANANA, deg: 3 },
        { slot: 'secondary', l: '-11%', bt: '-26%', w: '67%', h: '61%', s: SHAPE_COMMA, deg: -4 },
        { slot: 'accent', t: '-7%', l: '-8%', w: '83%', h: '75%', s: SHAPE_WISP, deg: -45 },
        { slot: 'base', t: '-26%', rt: '-23%', w: '74%', h: '58%', s: SHAPE_VERT_CRESCENT, deg: 16 },
    ],
    supply_chain_and_logistics: [
        { slot: 'primary', rt: '36%', bt: '34%', w: '81%', h: '61%', s: SHAPE_BANANA, deg: 35 },
        { slot: 'secondary', l: '-9%', bt: '-9%', w: '61%', h: '72%', s: SHAPE_HOOK, deg: 19 },
        { slot: 'accent', t: '-28%', rt: '-15%', w: '67%', h: '71%', s: SHAPE_WISP, deg: 6 },
        { slot: 'base', l: '32%', bt: '21%', w: '78%', h: '71%', s: SHAPE_SPIRAL, deg: -40 },
    ],
    academia: [
        { slot: 'primary', t: '-28%', rt: '-18%', w: '73%', h: '65%', s: SHAPE_HOOK, deg: -4 },
        { slot: 'secondary', l: '-25%', bt: '-21%', w: '60%', h: '70%', s: SHAPE_COMMA, deg: 23 },
        { slot: 'accent', t: '37%', l: '30%', w: '70%', h: '75%', s: SHAPE_VERT_CRESCENT, deg: 35 },
        { slot: 'base', rt: '23%', bt: '20%', w: '64%', h: '60%', s: SHAPE_BANANA, deg: 12 },
    ],
    administration: [
        { slot: 'primary', t: '17%', rt: '39%', w: '71%', h: '78%', s: SHAPE_WISP, deg: 39 },
        { slot: 'secondary', l: '-22%', bt: '-28%', w: '83%', h: '77%', s: SHAPE_BANANA, deg: -28 },
        { slot: 'accent', t: '-6%', l: '-26%', w: '68%', h: '62%', s: SHAPE_COMMA, deg: 33 },
        { slot: 'base', t: '-24%', rt: '-8%', w: '67%', h: '74%', s: SHAPE_HOOK, deg: -36 },
    ],
    adult_training: [
        { slot: 'primary', l: '-24%', bt: '-22%', w: '61%', h: '71%', s: SHAPE_BANANA, deg: 11 },
        { slot: 'secondary', t: '-12%', l: '-6%', w: '72%', h: '72%', s: SHAPE_BANANA, deg: 42 },
        { slot: 'accent', rt: '-11%', bt: '-9%', w: '67%', h: '69%', s: SHAPE_BANANA, deg: -22 },
        { slot: 'base', t: '17%', l: '17%', w: '75%', h: '61%', s: SHAPE_COMMA, deg: -34 },
    ],
    early_childhood: [
        { slot: 'primary', rt: '-7%', bt: '-19%', w: '69%', h: '76%', s: SHAPE_COMMA, deg: 37 },
        { slot: 'secondary', t: '33%', rt: '35%', w: '79%', h: '72%', s: SHAPE_COMMA, deg: 10 },
        { slot: 'accent', t: '-25%', rt: '-22%', w: '83%', h: '55%', s: SHAPE_WISP, deg: -13 },
        { slot: 'base', t: '23%', l: '30%', w: '82%', h: '67%', s: SHAPE_VERT_CRESCENT, deg: 43 },
    ],
    social_work: [
        { slot: 'primary', l: '-10%', bt: '-7%', w: '77%', h: '63%', s: SHAPE_SPIRAL, deg: 7 },
        { slot: 'secondary', l: '33%', bt: '26%', w: '61%', h: '73%', s: SHAPE_SPIRAL, deg: 34 },
        { slot: 'accent', rt: '-8%', bt: '-23%', w: '81%', h: '74%', s: SHAPE_SPIRAL, deg: 46 },
        { slot: 'base', t: '-14%', rt: '-14%', w: '61%', h: '59%', s: SHAPE_VERT_CRESCENT, deg: 20 },
    ],
    teaching: [
        { slot: 'primary', rt: '35%', bt: '29%', w: '82%', h: '62%', s: SHAPE_BANANA, deg: -29 },
        {
            slot: 'secondary',
            t: '-12%',
            l: '-17%',
            w: '68%',
            h: '61%',
            s: SHAPE_VERT_CRESCENT,
            deg: 16,
        },
        { slot: 'accent', l: '24%', bt: '30%', w: '73%', h: '60%', s: SHAPE_WISP, deg: 37 },
        { slot: 'base', l: '-23%', bt: '-24%', w: '72%', h: '80%', s: SHAPE_SPIRAL, deg: 32 },
    ],
    armed_services: [
        { slot: 'primary', l: '35%', bt: '30%', w: '84%', h: '63%', s: SHAPE_SPIRAL, deg: -27 },
        { slot: 'secondary', rt: '36%', bt: '35%', w: '76%', h: '69%', s: SHAPE_BANANA, deg: -42 },
        { slot: 'accent', l: '-9%', bt: '-23%', w: '66%', h: '73%', s: SHAPE_HOOK, deg: 6 },
        { slot: 'base', t: '-14%', rt: '-9%', w: '77%', h: '66%', s: SHAPE_SPIRAL, deg: 38 },
    ],
    criminal_justice: [
        { slot: 'primary', rt: '20%', bt: '34%', w: '68%', h: '80%', s: SHAPE_VERT_CRESCENT, deg: -48 },
        { slot: 'secondary', rt: '-30%', bt: '-27%', w: '73%', h: '78%', s: SHAPE_COMMA, deg: -26 },
        { slot: 'accent', l: '-24%', bt: '-25%', w: '63%', h: '78%', s: SHAPE_BANANA, deg: 0 },
        { slot: 'base', l: '21%', bt: '29%', w: '71%', h: '64%', s: SHAPE_SPIRAL, deg: 47 },
    ],
    law: [
        { slot: 'primary', l: '37%', bt: '34%', w: '65%', h: '71%', s: SHAPE_WISP, deg: 8 },
        {
            slot: 'secondary',
            l: '-17%',
            bt: '-29%',
            w: '65%',
            h: '74%',
            s: SHAPE_VERT_CRESCENT,
            deg: 29,
        },
        { slot: 'accent', rt: '15%', bt: '30%', w: '67%', h: '79%', s: SHAPE_COMMA, deg: 39 },
        { slot: 'base', t: '-25%', rt: '-13%', w: '66%', h: '80%', s: SHAPE_VERT_CRESCENT, deg: -36 },
    ],
    public_civil_service: [
        { slot: 'primary', t: '39%', l: '34%', w: '65%', h: '68%', s: SHAPE_COMMA, deg: -41 },
        { slot: 'secondary', t: '39%', rt: '17%', w: '82%', h: '78%', s: SHAPE_WISP, deg: -20 },
        { slot: 'accent', l: '-5%', bt: '-6%', w: '64%', h: '63%', s: SHAPE_BANANA, deg: -25 },
        { slot: 'base', rt: '-24%', bt: '-8%', w: '60%', h: '68%', s: SHAPE_BANANA, deg: -39 },
    ],
    dentistry: [
        { slot: 'primary', l: '-14%', bt: '-6%', w: '72%', h: '70%', s: SHAPE_SPIRAL, deg: -28 },
        {
            slot: 'secondary',
            rt: '38%',
            bt: '34%',
            w: '82%',
            h: '79%',
            s: SHAPE_VERT_CRESCENT,
            deg: 10,
        },
        { slot: 'accent', t: '-11%', rt: '-27%', w: '72%', h: '59%', s: SHAPE_HOOK, deg: -19 },
        { slot: 'base', t: '34%', rt: '23%', w: '77%', h: '67%', s: SHAPE_HOOK, deg: 47 },
    ],
    healthcare_technicians: [
        { slot: 'primary', l: '-6%', bt: '-26%', w: '68%', h: '68%', s: SHAPE_BANANA, deg: 18 },
        { slot: 'secondary', l: '27%', bt: '27%', w: '82%', h: '58%', s: SHAPE_SPIRAL, deg: 46 },
        { slot: 'accent', t: '-15%', rt: '-7%', w: '71%', h: '62%', s: SHAPE_HOOK, deg: 0 },
        { slot: 'base', t: '27%', l: '22%', w: '78%', h: '79%', s: SHAPE_WISP, deg: 26 },
    ],
    medical_research: [
        { slot: 'primary', l: '-6%', bt: '-23%', w: '79%', h: '78%', s: SHAPE_SPIRAL, deg: 35 },
        { slot: 'secondary', t: '28%', l: '22%', w: '69%', h: '68%', s: SHAPE_HOOK, deg: -40 },
        { slot: 'accent', t: '-27%', rt: '-8%', w: '82%', h: '78%', s: SHAPE_COMMA, deg: 28 },
        { slot: 'base', l: '31%', bt: '39%', w: '64%', h: '72%', s: SHAPE_COMMA, deg: -45 },
    ],
    medicine: [
        { slot: 'primary', l: '17%', bt: '19%', w: '81%', h: '57%', s: SHAPE_COMMA, deg: -29 },
        { slot: 'secondary', t: '20%', l: '19%', w: '81%', h: '65%', s: SHAPE_COMMA, deg: 47 },
        { slot: 'accent', l: '-15%', bt: '-12%', w: '77%', h: '71%', s: SHAPE_COMMA, deg: 11 },
        { slot: 'base', t: '-26%', rt: '-13%', w: '61%', h: '78%', s: SHAPE_COMMA, deg: 22 },
    ],
    mental_health: [
        { slot: 'primary', t: '-19%', l: '-29%', w: '78%', h: '76%', s: SHAPE_VERT_CRESCENT, deg: -16 },
        { slot: 'secondary', t: '39%', l: '25%', w: '65%', h: '62%', s: SHAPE_SPIRAL, deg: 31 },
        { slot: 'accent', t: '-22%', rt: '-23%', w: '74%', h: '60%', s: SHAPE_COMMA, deg: -35 },
        { slot: 'base', t: '27%', rt: '23%', w: '61%', h: '76%', s: SHAPE_VERT_CRESCENT, deg: -47 },
    ],
    nursing: [
        { slot: 'primary', l: '-8%', bt: '-14%', w: '72%', h: '61%', s: SHAPE_WISP, deg: 25 },
        { slot: 'secondary', rt: '20%', bt: '23%', w: '73%', h: '72%', s: SHAPE_HOOK, deg: -50 },
        { slot: 'accent', t: '-18%', rt: '-9%', w: '61%', h: '70%', s: SHAPE_BANANA, deg: -23 },
        { slot: 'base', t: '-28%', l: '-25%', w: '80%', h: '68%', s: SHAPE_BANANA, deg: -33 },
    ],
    nutrition: [
        { slot: 'primary', l: '37%', bt: '17%', w: '65%', h: '61%', s: SHAPE_WISP, deg: 43 },
        { slot: 'secondary', t: '16%', rt: '26%', w: '67%', h: '64%', s: SHAPE_SPIRAL, deg: 20 },
        { slot: 'accent', l: '-24%', bt: '-7%', w: '61%', h: '78%', s: SHAPE_COMMA, deg: 13 },
        { slot: 'base', t: '26%', l: '35%', w: '77%', h: '71%', s: SHAPE_WISP, deg: -25 },
    ],
    occupational_therapy: [
        { slot: 'primary', t: '24%', rt: '30%', w: '79%', h: '62%', s: SHAPE_BANANA, deg: 47 },
        { slot: 'secondary', rt: '-9%', bt: '-9%', w: '60%', h: '65%', s: SHAPE_HOOK, deg: 2 },
        { slot: 'accent', rt: '27%', bt: '28%', w: '68%', h: '78%', s: SHAPE_BANANA, deg: -15 },
        { slot: 'base', l: '-20%', bt: '-5%', w: '85%', h: '66%', s: SHAPE_HOOK, deg: -23 },
    ],
    pharmacy: [
        { slot: 'primary', l: '-16%', bt: '-12%', w: '79%', h: '71%', s: SHAPE_WISP, deg: -16 },
        { slot: 'secondary', rt: '29%', bt: '18%', w: '84%', h: '71%', s: SHAPE_SPIRAL, deg: -24 },
        { slot: 'accent', rt: '-20%', bt: '-7%', w: '81%', h: '76%', s: SHAPE_WISP, deg: -15 },
        { slot: 'base', t: '22%', rt: '37%', w: '61%', h: '67%', s: SHAPE_VERT_CRESCENT, deg: -36 },
    ],
    physical_therapy: [
        { slot: 'primary', t: '15%', rt: '34%', w: '79%', h: '67%', s: SHAPE_VERT_CRESCENT, deg: 17 },
        {
            slot: 'secondary',
            t: '-6%',
            rt: '-25%',
            w: '77%',
            h: '77%',
            s: SHAPE_VERT_CRESCENT,
            deg: -46,
        },
        { slot: 'accent', t: '22%', l: '23%', w: '85%', h: '70%', s: SHAPE_VERT_CRESCENT, deg: -15 },
        { slot: 'base', rt: '25%', bt: '32%', w: '63%', h: '66%', s: SHAPE_HOOK, deg: 22 },
    ],
    physician_assistance: [
        { slot: 'primary', l: '16%', bt: '30%', w: '74%', h: '58%', s: SHAPE_BANANA, deg: -15 },
        {
            slot: 'secondary',
            rt: '-16%',
            bt: '-25%',
            w: '72%',
            h: '75%',
            s: SHAPE_VERT_CRESCENT,
            deg: 21,
        },
        { slot: 'accent', t: '-14%', rt: '-10%', w: '63%', h: '69%', s: SHAPE_WISP, deg: 28 },
        { slot: 'base', t: '31%', l: '32%', w: '61%', h: '75%', s: SHAPE_WISP, deg: -28 },
    ],
    public_health: [
        { slot: 'primary', rt: '35%', bt: '26%', w: '79%', h: '62%', s: SHAPE_BANANA, deg: 8 },
        { slot: 'secondary', t: '29%', l: '25%', w: '62%', h: '76%', s: SHAPE_SPIRAL, deg: -28 },
        { slot: 'accent', l: '-16%', bt: '-25%', w: '66%', h: '57%', s: SHAPE_SPIRAL, deg: 38 },
        { slot: 'base', t: '19%', rt: '34%', w: '63%', h: '63%', s: SHAPE_VERT_CRESCENT, deg: 13 },
    ],
    speech_pathology: [
        { slot: 'primary', t: '-8%', rt: '-30%', w: '64%', h: '72%', s: SHAPE_HOOK, deg: 5 },
        { slot: 'secondary', rt: '-21%', bt: '-24%', w: '82%', h: '64%', s: SHAPE_COMMA, deg: -18 },
        { slot: 'accent', t: '36%', rt: '31%', w: '84%', h: '66%', s: SHAPE_COMMA, deg: 4 },
        { slot: 'base', rt: '29%', bt: '37%', w: '68%', h: '62%', s: SHAPE_HOOK, deg: -5 },
    ],
    aerospace_engineering: [
        { slot: 'primary', t: '-24%', rt: '-8%', w: '65%', h: '61%', s: SHAPE_BANANA, deg: -31 },
        { slot: 'secondary', rt: '-29%', bt: '-7%', w: '80%', h: '67%', s: SHAPE_BANANA, deg: 14 },
        { slot: 'accent', t: '23%', rt: '26%', w: '70%', h: '79%', s: SHAPE_WISP, deg: 20 },
        { slot: 'base', rt: '31%', bt: '27%', w: '65%', h: '66%', s: SHAPE_VERT_CRESCENT, deg: -23 },
    ],
    biomedical_engineering: [
        { slot: 'primary', rt: '-7%', bt: '-22%', w: '84%', h: '63%', s: SHAPE_WISP, deg: 16 },
        { slot: 'secondary', t: '17%', rt: '17%', w: '65%', h: '76%', s: SHAPE_COMMA, deg: -40 },
        { slot: 'accent', t: '37%', l: '31%', w: '83%', h: '65%', s: SHAPE_BANANA, deg: 11 },
        { slot: 'base', rt: '26%', bt: '29%', w: '80%', h: '59%', s: SHAPE_VERT_CRESCENT, deg: 43 },
    ],
    chemical_engineering: [
        { slot: 'primary', rt: '-10%', bt: '-22%', w: '76%', h: '79%', s: SHAPE_HOOK, deg: 28 },
        { slot: 'secondary', l: '15%', bt: '24%', w: '79%', h: '55%', s: SHAPE_HOOK, deg: -33 },
        { slot: 'accent', rt: '39%', bt: '26%', w: '76%', h: '60%', s: SHAPE_BANANA, deg: 41 },
        { slot: 'base', t: '34%', rt: '37%', w: '79%', h: '62%', s: SHAPE_HOOK, deg: -6 },
    ],
    civil_engineering: [
        { slot: 'primary', l: '-17%', bt: '-11%', w: '84%', h: '71%', s: SHAPE_WISP, deg: 23 },
        { slot: 'secondary', rt: '-5%', bt: '-9%', w: '74%', h: '59%', s: SHAPE_SPIRAL, deg: -41 },
        { slot: 'accent', t: '-17%', rt: '-18%', w: '84%', h: '75%', s: SHAPE_SPIRAL, deg: -28 },
        { slot: 'base', l: '26%', bt: '32%', w: '63%', h: '57%', s: SHAPE_HOOK, deg: -32 },
    ],
    data_science_analytics: [
        { slot: 'primary', t: '-11%', l: '-5%', w: '71%', h: '58%', s: SHAPE_WISP, deg: 14 },
        { slot: 'secondary', rt: '-25%', bt: '-20%', w: '83%', h: '72%', s: SHAPE_SPIRAL, deg: 13 },
        { slot: 'accent', l: '26%', bt: '37%', w: '77%', h: '63%', s: SHAPE_VERT_CRESCENT, deg: 39 },
        { slot: 'base', t: '22%', rt: '19%', w: '70%', h: '62%', s: SHAPE_SPIRAL, deg: -13 },
    ],
    digital_consulting: [
        { slot: 'primary', l: '-17%', bt: '-22%', w: '62%', h: '70%', s: SHAPE_COMMA, deg: -16 },
        { slot: 'secondary', t: '-29%', rt: '-14%', w: '71%', h: '62%', s: SHAPE_BANANA, deg: -34 },
        { slot: 'accent', t: '18%', rt: '23%', w: '81%', h: '57%', s: SHAPE_WISP, deg: -8 },
        { slot: 'base', t: '-13%', l: '-24%', w: '63%', h: '60%', s: SHAPE_BANANA, deg: 23 },
    ],
    digital_security: [
        { slot: 'primary', t: '-19%', l: '-10%', w: '72%', h: '56%', s: SHAPE_VERT_CRESCENT, deg: 3 },
        { slot: 'secondary', l: '-26%', bt: '-25%', w: '66%', h: '79%', s: SHAPE_COMMA, deg: -27 },
        { slot: 'accent', l: '38%', bt: '18%', w: '77%', h: '79%', s: SHAPE_SPIRAL, deg: -2 },
        { slot: 'base', t: '21%', rt: '31%', w: '79%', h: '59%', s: SHAPE_COMMA, deg: -42 },
    ],
    electrical_engineering: [
        { slot: 'primary', l: '-18%', bt: '-17%', w: '71%', h: '69%', s: SHAPE_HOOK, deg: -13 },
        { slot: 'secondary', rt: '35%', bt: '19%', w: '79%', h: '64%', s: SHAPE_BANANA, deg: 18 },
        { slot: 'accent', t: '37%', l: '40%', w: '78%', h: '67%', s: SHAPE_BANANA, deg: -7 },
        { slot: 'base', l: '20%', bt: '32%', w: '76%', h: '60%', s: SHAPE_VERT_CRESCENT, deg: 9 },
    ],
    environmental_engineering: [
        { slot: 'primary', l: '-10%', bt: '-7%', w: '71%', h: '80%', s: SHAPE_SPIRAL, deg: -33 },
        { slot: 'secondary', t: '19%', rt: '24%', w: '68%', h: '57%', s: SHAPE_SPIRAL, deg: -33 },
        { slot: 'accent', t: '-17%', rt: '-6%', w: '73%', h: '67%', s: SHAPE_WISP, deg: -27 },
        { slot: 'base', rt: '26%', bt: '21%', w: '79%', h: '67%', s: SHAPE_HOOK, deg: -11 },
    ],
    mechanical_engineering: [
        { slot: 'primary', l: '-6%', bt: '-22%', w: '61%', h: '60%', s: SHAPE_SPIRAL, deg: -19 },
        { slot: 'secondary', rt: '28%', bt: '30%', w: '64%', h: '67%', s: SHAPE_HOOK, deg: 19 },
        { slot: 'accent', t: '26%', rt: '28%', w: '68%', h: '57%', s: SHAPE_VERT_CRESCENT, deg: -7 },
        { slot: 'base', l: '27%', bt: '32%', w: '73%', h: '78%', s: SHAPE_HOOK, deg: 28 },
    ],
    biotech_applied_sciences: [
        { slot: 'primary', t: '-7%', l: '-9%', w: '79%', h: '57%', s: SHAPE_HOOK, deg: -31 },
        { slot: 'secondary', t: '24%', rt: '36%', w: '79%', h: '64%', s: SHAPE_HOOK, deg: -7 },
        { slot: 'accent', t: '30%', l: '35%', w: '79%', h: '75%', s: SHAPE_HOOK, deg: -19 },
        { slot: 'base', rt: '20%', bt: '32%', w: '71%', h: '60%', s: SHAPE_WISP, deg: 47 },
    ],
    network_systems: [
        { slot: 'primary', l: '-20%', bt: '-19%', w: '73%', h: '75%', s: SHAPE_HOOK, deg: 23 },
        { slot: 'secondary', t: '-20%', rt: '-12%', w: '71%', h: '76%', s: SHAPE_COMMA, deg: -1 },
        { slot: 'accent', l: '38%', bt: '36%', w: '75%', h: '79%', s: SHAPE_VERT_CRESCENT, deg: -49 },
        { slot: 'base', t: '-26%', l: '-6%', w: '80%', h: '72%', s: SHAPE_VERT_CRESCENT, deg: 22 },
    ],
    software_development: [
        { slot: 'primary', t: '40%', l: '36%', w: '68%', h: '70%', s: SHAPE_COMMA, deg: -22 },
        { slot: 'secondary', rt: '26%', bt: '19%', w: '74%', h: '70%', s: SHAPE_SPIRAL, deg: -18 },
        { slot: 'accent', rt: '-25%', bt: '-25%', w: '84%', h: '78%', s: SHAPE_BANANA, deg: 25 },
        { slot: 'base', t: '-27%', l: '-10%', w: '62%', h: '80%', s: SHAPE_HOOK, deg: -8 },
    ],
    advocacy: [
        { slot: 'primary', rt: '-13%', bt: '-13%', w: '65%', h: '56%', s: SHAPE_BANANA, deg: -44 },
        { slot: 'secondary', t: '38%', l: '27%', w: '68%', h: '69%', s: SHAPE_SPIRAL, deg: -37 },
        { slot: 'accent', l: '-6%', bt: '-29%', w: '74%', h: '60%', s: SHAPE_BANANA, deg: 13 },
        { slot: 'base', t: '16%', rt: '28%', w: '83%', h: '76%', s: SHAPE_WISP, deg: 15 },
    ],
    'non-profit': [
        { slot: 'primary', t: '-19%', l: '-8%', w: '76%', h: '70%', s: SHAPE_WISP, deg: -39 },
        { slot: 'secondary', t: '29%', l: '16%', w: '80%', h: '60%', s: SHAPE_HOOK, deg: 30 },
        { slot: 'accent', rt: '38%', bt: '27%', w: '81%', h: '73%', s: SHAPE_COMMA, deg: 47 },
        { slot: 'base', t: '22%', rt: '35%', w: '78%', h: '75%', s: SHAPE_BANANA, deg: 1 },
    ],
    religious: [
        { slot: 'primary', l: '29%', bt: '36%', w: '64%', h: '60%', s: SHAPE_WISP, deg: 37 },
        { slot: 'secondary', t: '25%', l: '38%', w: '79%', h: '74%', s: SHAPE_WISP, deg: -23 },
        { slot: 'accent', rt: '23%', bt: '39%', w: '68%', h: '69%', s: SHAPE_VERT_CRESCENT, deg: 24 },
        { slot: 'base', t: '-10%', rt: '-29%', w: '82%', h: '74%', s: SHAPE_COMMA, deg: 35 },
    ],
    agriculture: [
        { slot: 'primary', t: '15%', rt: '29%', w: '67%', h: '55%', s: SHAPE_BANANA, deg: 47 },
        { slot: 'secondary', l: '24%', bt: '30%', w: '81%', h: '79%', s: SHAPE_COMMA, deg: 15 },
        { slot: 'accent', t: '38%', l: '19%', w: '64%', h: '73%', s: SHAPE_SPIRAL, deg: -32 },
        { slot: 'base', l: '-29%', bt: '-25%', w: '72%', h: '62%', s: SHAPE_COMMA, deg: 10 },
    ],
    construction: [
        { slot: 'primary', t: '-20%', l: '-13%', w: '64%', h: '70%', s: SHAPE_COMMA, deg: 32 },
        { slot: 'secondary', t: '23%', rt: '20%', w: '69%', h: '72%', s: SHAPE_BANANA, deg: -19 },
        { slot: 'accent', t: '28%', l: '30%', w: '70%', h: '57%', s: SHAPE_HOOK, deg: -13 },
        { slot: 'base', t: '-28%', rt: '-9%', w: '82%', h: '75%', s: SHAPE_BANANA, deg: -22 },
    ],
    manufacturing: [
        { slot: 'primary', rt: '33%', bt: '40%', w: '74%', h: '74%', s: SHAPE_BANANA, deg: 2 },
        { slot: 'secondary', rt: '-12%', bt: '-16%', w: '64%', h: '65%', s: SHAPE_BANANA, deg: -24 },
        { slot: 'accent', l: '32%', bt: '36%', w: '70%', h: '75%', s: SHAPE_COMMA, deg: -48 },
        { slot: 'base', t: '40%', rt: '28%', w: '69%', h: '69%', s: SHAPE_WISP, deg: 37 },
    ],
    hospitality_food_services: [
        { slot: 'primary', rt: '18%', bt: '24%', w: '83%', h: '68%', s: SHAPE_WISP, deg: 3 },
        { slot: 'secondary', t: '-18%', l: '-28%', w: '80%', h: '73%', s: SHAPE_HOOK, deg: -5 },
        { slot: 'accent', l: '20%', bt: '26%', w: '72%', h: '76%', s: SHAPE_BANANA, deg: -30 },
        { slot: 'base', t: '30%', l: '19%', w: '79%', h: '76%', s: SHAPE_SPIRAL, deg: 45 },
    ],
    transportation_delivery_services: [
        { slot: 'primary', l: '32%', bt: '22%', w: '69%', h: '73%', s: SHAPE_WISP, deg: 24 },
        { slot: 'secondary', t: '-16%', rt: '-17%', w: '60%', h: '59%', s: SHAPE_HOOK, deg: 2 },
        { slot: 'accent', t: '-21%', l: '-14%', w: '73%', h: '58%', s: SHAPE_WISP, deg: 43 },
        { slot: 'base', rt: '37%', bt: '18%', w: '66%', h: '59%', s: SHAPE_WISP, deg: 4 },
    ],
    maintenance_facility_services: [
        { slot: 'primary', rt: '31%', bt: '17%', w: '80%', h: '78%', s: SHAPE_SPIRAL, deg: 23 },
        { slot: 'secondary', t: '-20%', l: '-19%', w: '84%', h: '59%', s: SHAPE_WISP, deg: 26 },
        { slot: 'accent', t: '35%', rt: '31%', w: '77%', h: '65%', s: SHAPE_HOOK, deg: -36 },
        { slot: 'base', l: '40%', bt: '15%', w: '77%', h: '57%', s: SHAPE_VERT_CRESCENT, deg: -11 },
    ],
    personal_care_lifestyle_services: [
        { slot: 'primary', rt: '-12%', bt: '-10%', w: '79%', h: '55%', s: SHAPE_VERT_CRESCENT, deg: 2 },
        { slot: 'secondary', l: '-21%', bt: '-22%', w: '63%', h: '69%', s: SHAPE_SPIRAL, deg: -37 },
        { slot: 'accent', rt: '20%', bt: '37%', w: '78%', h: '74%', s: SHAPE_COMMA, deg: -11 },
        { slot: 'base', t: '-17%', rt: '-26%', w: '80%', h: '60%', s: SHAPE_VERT_CRESCENT, deg: 43 },
    ],
    security_public_safety_support: [
        { slot: 'primary', t: '26%', rt: '28%', w: '69%', h: '63%', s: SHAPE_COMMA, deg: 18 },
        { slot: 'secondary', t: '38%', l: '18%', w: '74%', h: '71%', s: SHAPE_VERT_CRESCENT, deg: 21 },
        { slot: 'accent', t: '-9%', rt: '-12%', w: '74%', h: '69%', s: SHAPE_COMMA, deg: 41 },
        { slot: 'base', rt: '16%', bt: '33%', w: '69%', h: '66%', s: SHAPE_COMMA, deg: 19 },
    ],
    customer_administrative_services: [
        { slot: 'primary', t: '24%', rt: '20%', w: '67%', h: '58%', s: SHAPE_WISP, deg: -10 },
        { slot: 'secondary', rt: '-11%', bt: '-19%', w: '75%', h: '67%', s: SHAPE_HOOK, deg: -48 },
        { slot: 'accent', t: '-24%', l: '-27%', w: '85%', h: '57%', s: SHAPE_VERT_CRESCENT, deg: 35 },
        { slot: 'base', rt: '40%', bt: '15%', w: '77%', h: '61%', s: SHAPE_SPIRAL, deg: 22 },
    ],
    retail: [
        { slot: 'primary', l: '-8%', bt: '-11%', w: '66%', h: '74%', s: SHAPE_COMMA, deg: -33 },
        { slot: 'secondary', l: '26%', bt: '34%', w: '66%', h: '58%', s: SHAPE_WISP, deg: -41 },
        { slot: 'accent', t: '37%', l: '17%', w: '82%', h: '77%', s: SHAPE_VERT_CRESCENT, deg: 49 },
        { slot: 'base', t: '-28%', l: '-14%', w: '65%', h: '75%', s: SHAPE_WISP, deg: -47 },
    ],
};
var isInternshipRoleType = function (roleType) {
    return (roleType !== null && roleType !== void 0 ? roleType : '').toLowerCase().includes('intern');
};
var accentForRoleType = function (roleType) {
    return isInternshipRoleType(roleType) ? 'Warning/400' : 'Brand/600';
};
var SCHOLARSHIP_PALETTE = {
    base: 'Beige/50',
    primary: 'Brand/200',
    secondary: 'Brand/100',
};
var SCHOLARSHIP_COMPOSITIONS = {
    Scholarship: [
        { slot: 'primary', t: '36%', rt: '32%', w: '69%', h: '59%', s: SHAPE_BANANA, deg: 13 },
        { slot: 'secondary', t: '28%', l: '36%', w: '77%', h: '69%', s: SHAPE_COMMA, deg: 28 },
        { slot: 'accent', rt: '-17%', bt: '-6%', w: '74%', h: '62%', s: SHAPE_SPIRAL, deg: 1 },
        { slot: 'base', l: '-18%', bt: '-28%', w: '80%', h: '68%', s: SHAPE_HOOK, deg: 0 },
    ],
    Grant: [
        { slot: 'primary', t: '20%', rt: '37%', w: '62%', h: '76%', s: SHAPE_COMMA, deg: -49 },
        { slot: 'secondary', t: '-9%', l: '-22%', w: '69%', h: '60%', s: SHAPE_BANANA, deg: -11 },
        { slot: 'accent', l: '24%', bt: '16%', w: '81%', h: '73%', s: SHAPE_HOOK, deg: -3 },
        { slot: 'base', t: '26%', l: '19%', w: '65%', h: '67%', s: SHAPE_VERT_CRESCENT, deg: 39 },
    ],
    Prize: [
        { slot: 'primary', l: '40%', bt: '40%', w: '63%', h: '63%', s: SHAPE_WISP, deg: -12 },
        { slot: 'secondary', t: '-26%', l: '-6%', w: '85%', h: '59%', s: SHAPE_COMMA, deg: -33 },
        { slot: 'accent', rt: '-22%', bt: '-21%', w: '82%', h: '69%', s: SHAPE_SPIRAL, deg: 48 },
        { slot: 'base', rt: '29%', bt: '19%', w: '77%', h: '77%', s: SHAPE_WISP, deg: -48 },
    ],
    Fellowship: [
        { slot: 'primary', t: '31%', l: '24%', w: '80%', h: '61%', s: SHAPE_WISP, deg: -50 },
        { slot: 'secondary', l: '32%', bt: '23%', w: '62%', h: '60%', s: SHAPE_HOOK, deg: -8 },
        { slot: 'accent', t: '-24%', l: '-21%', w: '70%', h: '68%', s: SHAPE_BANANA, deg: 22 },
        { slot: 'base', t: '30%', rt: '37%', w: '77%', h: '72%', s: SHAPE_COMMA, deg: 33 },
    ],
    'Forgivable Loan': [
        { slot: 'primary', t: '-27%', rt: '-7%', w: '67%', h: '76%', s: SHAPE_BANANA, deg: 43 },
        { slot: 'secondary', t: '23%', rt: '39%', w: '63%', h: '61%', s: SHAPE_HOOK, deg: -10 },
        { slot: 'accent', t: '-16%', l: '-14%', w: '67%', h: '61%', s: SHAPE_BANANA, deg: -11 },
        { slot: 'base', l: '23%', bt: '19%', w: '74%', h: '68%', s: SHAPE_VERT_CRESCENT, deg: 48 },
    ],
};
export var buildScholarshipMeshConfig = function (awardType) {
    return buildConfig(__assign(__assign({}, SCHOLARSHIP_PALETTE), { accent: 'Error/400' }), SCHOLARSHIP_COMPOSITIONS[awardType]);
};
export var buildInternshipMeshConfig = function (pathCode, field, accent) { var _a; return buildConfig(__assign(__assign({}, FIELD_PALETTES[field]), { accent: accent }), (_a = PATH_COMPOSITIONS[pathCode]) !== null && _a !== void 0 ? _a : []); };
var hashSeed = function (seed) {
    var hash = 0;
    for (var i = 0; i < seed.length; i++) {
        hash = (Math.imul(hash, 31) + seed.charCodeAt(i)) | 0;
    }
    return hash >>> 0;
};
var SEED_PALETTES = [
    BLUES_SOFT,
    BLUES_DEEP,
    BLUES_MID,
    COOL_CRISP,
    YELLOW_ACCENT,
    YELLOW_LIGHT,
    YELLOW_AIRY,
    RED_ACCENT,
    RED_MID,
    RED_SOFT,
];
var BANNER_COMPOSITIONS = [
    [
        { slot: 'primary', l: '-10%', t: '-18%', w: '62%', h: '105%', s: SHAPE_WISP, deg: -18 },
        { slot: 'secondary', rt: '0%', bt: '-16%', w: '62%', h: '105%', s: SHAPE_SPIRAL, deg: 22 },
        { slot: 'accent', l: '26%', t: '-14%', w: '60%', h: '105%', s: SHAPE_HOOK, deg: -14 },
    ],
    [
        { slot: 'secondary', l: '-8%', bt: '-16%', w: '60%', h: '105%', s: SHAPE_COMMA, deg: 20 },
        { slot: 'primary', rt: '-2%', t: '-16%', w: '62%', h: '105%', s: SHAPE_HOOK, deg: 16 },
        { slot: 'accent', l: '30%', bt: '-12%', w: '60%', h: '105%', s: SHAPE_BANANA, deg: -22 },
    ],
    [
        { slot: 'primary', l: '-10%', bt: '-16%', w: '60%', h: '105%', s: SHAPE_SPIRAL, deg: 22 },
        { slot: 'secondary', rt: '-4%', t: '-16%', w: '62%', h: '105%', s: SHAPE_WISP, deg: -18 },
        { slot: 'accent', l: '28%', t: '-12%', w: '62%', h: '105%', s: SHAPE_BANANA, deg: 26 },
    ],
];
export var buildSeededMeshConfig = function (seed) {
    var hash = hashSeed(String(seed));
    var palette = SEED_PALETTES[hash % SEED_PALETTES.length];
    var composition = BANNER_COMPOSITIONS[(hash >>> 4) % BANNER_COMPOSITIONS.length];
    return buildConfig(palette, composition);
};
var isScholarshipAwardType = function (value) {
    return SCHOLARSHIP_AWARD_TYPES.includes(value !== null && value !== void 0 ? value : '');
};
export var resolveMeshConfig = function (nugget) {
    var _a, _b, _c, _d, _e, _f;
    if (nugget.variant === 'internship') {
        var path = (_b = (_a = nugget.internship_info) === null || _a === void 0 ? void 0 : _a.careerPaths) === null || _b === void 0 ? void 0 : _b[0];
        var fieldSlug = (_c = path === null || path === void 0 ? void 0 : path.career_category) === null || _c === void 0 ? void 0 : _c.slug;
        if (!(path === null || path === void 0 ? void 0 : path.code) || !fieldSlug)
            return DEFAULT_CONFIG;
        if (!PATH_COMPOSITIONS[path.code]) {
            console.warn('[resolveMeshConfig] no composition for career path code', { code: path.code });
            return DEFAULT_CONFIG;
        }
        if (!FIELD_PALETTES[fieldSlug]) {
            console.warn('[resolveMeshConfig] no palette for career field slug', { slug: fieldSlug });
            return DEFAULT_CONFIG;
        }
        return buildInternshipMeshConfig(path.code, fieldSlug, accentForRoleType((_d = nugget.internship_info) === null || _d === void 0 ? void 0 : _d.role_type));
    }
    if (nugget.variant === 'scholarships') {
        var awardType = (_e = nugget.scholarship_info) === null || _e === void 0 ? void 0 : _e.award_type;
        if (isScholarshipAwardType(awardType)) {
            return buildScholarshipMeshConfig(awardType);
        }
        if (awardType !== undefined) {
            console.warn('[resolveMeshConfig] unknown scholarship award_type', { awardType: awardType });
        }
        return buildScholarshipMeshConfig('Scholarship');
    }
    return (_f = PER_VARIANT[nugget.variant]) !== null && _f !== void 0 ? _f : DEFAULT_CONFIG;
};
